'use client'

export { CollapsibleBlockClient as CollapsibleBlock } from './Component.client'
